export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/Normalization.worker.fa7fa6e1.worker.js");
}
